export const ZODIAC_SIGNS = [
  { value: 'aries', label: '牡羊座' },
  { value: 'taurus', label: '金牛座' },
  { value: 'gemini', label: '雙子座' },
  { value: 'cancer', label: '巨蟹座' },
  { value: 'leo', label: '獅子座' },
  { value: 'virgo', label: '處女座' },
  { value: 'libra', label: '天秤座' },
  { value: 'scorpio', label: '天蠍座' },
  { value: 'sagittarius', label: '射手座' },
  { value: 'capricorn', label: '摩羯座' },
  { value: 'aquarius', label: '水瓶座' },
  { value: 'pisces', label: '雙魚座' },
];

export const ASTROLOGER_STYLES = [
  { value: 'traditional', label: '傳統占星師' },
  { value: 'modern', label: '現代占星師' },
  { value: 'humorous', label: '幽默占星師' },
  { value: 'mystical', label: '神秘占星師' },
];

